import React, { useEffect, useRef } from "react";
import nipplejs from "nipplejs";
import { COLORS } from "../constants";

/**
 * MobileJoystick — left-thumb virtual joystick (nipplejs) that writes to the
 * shared `inputRef` consumed by ThirdPersonWalker:
 *
 *   inputRef.current = { x: -1..1 (turn), y: -1..1 (forward) }
 *
 * Only rendered on touch devices, only while in walk mode.
 */
export default function MobileJoystick({ inputRef, visible }) {
  const containerRef = useRef(null);
  const managerRef = useRef(null);

  useEffect(() => {
    if (!visible || !containerRef.current) return;
    const m = nipplejs.create({
      zone: containerRef.current,
      mode: "static",
      position: { left: "50%", top: "50%" },
      color: COLORS.gold,
      size: 110,
      restOpacity: 0.6,
    });
    managerRef.current = m;

    m.on("move", (_, data) => {
      if (!data || !data.vector) return;
      // nipplejs vector: x in [-1,1] (right positive), y in [-1,1] (up positive)
      inputRef.current.y = data.vector.y;
      inputRef.current.x = -data.vector.x; // invert so right turns avatar right
    });
    m.on("end", () => {
      inputRef.current.x = 0;
      inputRef.current.y = 0;
    });

    return () => {
      try {
        m.destroy();
      } catch (e) {
        /* ignore */
      }
      managerRef.current = null;
      inputRef.current.x = 0;
      inputRef.current.y = 0;
    };
  }, [visible, inputRef]);

  if (!visible) return null;

  return (
    <div
      data-testid="zone-mobile-joystick"
      ref={containerRef}
      style={{
        position: "fixed",
        bottom: 32,
        left: 32,
        width: 160,
        height: 160,
        zIndex: 50,
        touchAction: "none",
        // The nipple is positioned in the centre of this box.
      }}
    />
  );
}
